module.exports = __webpack_public_path__ + "static/media/heli.9b491515.png";